<template>
  <div class="warp" style="padding: 0 20px; height: calc(100vh - 80px); overflow: auto">
    <div style="margin-bottom: 10px">
      <el-button
        size="small" type="primary" @click="exportToExcel"
      >{{ $t('newOrder.export') }}
      </el-button>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="(item, index) in tableHeaderList"
        :key="index"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] || '--' }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination
        :current-page.sync="searchForm.pageNumber"
        :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 15px 0"
        @current-change="getSearch"
        @size-change="getSearch"
      />
    </div>
  </div>
</template>

<script>
import { bagRecycleSummaryDetails, bagRecycleSummaryDetailsExport } from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  props: {
    dataobj: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumber: ''
        }
      },
      tableData: [],
      total: 0,
      tableHeaderList: [
        {
          id: 1,
          label: this.$t('GlobalSetObj.DocumentNumber'),
          prop: 'docNo',
          cloWidth: 140
        },
        {
          id: 3,
          label: this.$t('home.adjustSiteName'),
          prop: 'adjustSiteName',
          cloWidth: 160
        },
        {
          id: 111,
          label: this.$t('home.adjustCount'),
          prop: 'adjustCount',
          cloWidth: 160
        },
        {
          id: 7,
          label: this.$t('home.adjustReason'),
          prop: 'adjustReason',
          cloWidth: 160
        },
        {
          id: 8,
          label: this.$t('home.adjustMan'),
          prop: 'adjustMan',
          cloWidth: 160
        },
        {
          id: 1111,
          label: this.$t('home.adjustTime'),
          prop: 'adjustTime',
          cloWidth: '180px',
          align: 'center'
        }
      ]
    };
  },
  created() {
    this.getSearch();
  },
  methods: {
    getSearch() {
      const data = {
        pageNumber: this.searchForm.pageNumber,
        pageSize: this.searchForm.pageSize,
        params: {
          dataType: this.dataobj.dataType,
          siteId: this.dataobj.siteId,
          startTime: this.dataobj.startTime,
          endTime: this.dataobj.endTime
        }
      };
      bagRecycleSummaryDetails(data).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    exportToExcel() {
      const data = {
        dataType: this.dataobj.dataType,
        siteId: this.dataobj.siteId,
        startTime: this.dataobj.startTime,
        endTime: this.dataobj.endTime
      };
      bagRecycleSummaryDetailsExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    resetForm() {
      this.searchForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumber: ''
        }
      };
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}

.warp >>> .el-form-item {
  margin-bottom: 0 !important;
}
</style>
